import { UnifiedWithdrawFormTranslations } from "./unified-withdraw-form-pt-br";

export const UNIFIED_WITHDRAW_FORM_ES_MX: UnifiedWithdrawFormTranslations = {
	drawerTitle: "Retiro y Transferencia",
	steps: {
		information: "Información",
		review: "Revisión",
	},
	totalBalance: "Saldo Total",
	sendTo: "Enviar a",
	sendToPlaceholder: "Escriba o seleccione la cuenta",
	addNewAccount: "+ Añadir nueva cuenta",
	defaultAccountBadge: "Cuenta predeterminada",
	liquidValue: "Valor Líquido",
	liquidValuePlaceholder: "$ 0.00",
	reason: "Motivo de la solicitud",
	reasonPlaceholder: "Escriba el motivo del retiro",
	goBack: "Volver",
	goForward: "Continuar",
	submit: "Solicitar retiro",
	errorMessage: "No pudimos procesar su solicitud. Inténtelo de nuevo.",
	successMessage: "¡Su solicitud de retiro se envió con éxito!",
	splitBar: {
		available: "Disponible",
		anticipation: "Anticipación",
	},
	totalChipGross: "Total con tarifas",
	anticipationFee: "Tarifa de anticipación",
	thirdPartyFee: "Tarifa para cuenta de terceros",
	valueAboveTotal: "Valor solicitado mayor que el valor total con tarifas ({{value}})",
	feeError: {
		message: "No fue posible consultar la tarifa de anticipación. Inténtelo de nuevo.",
		retry: "Reintentar",
	},
	review: {
		valuesReview: "Revisión de los Valores",
		typeLabel: "Tipo",
		typeWithdraw: "Retiro",
		typeWithdrawAndAnticipation: "Retiro + Anticipación",
		statusLabel: "Estado",
		statusPending: "Procesando",
		requestedValue: "Valor solicitado",
		walletValue: "Valor en cartera",
		anticipatedValue: "Valor anticipado",
		thirdPartyFeeLabel: "Tarifa para cuenta de terceros",
		anticipationFeeLabel: "Tarifa de anticipación",
		grossValue: "Valor Bruto",
		netValueToAccount: "Valor neto",
		amountToReceive: "Valor a recibir",
		attentionBannerTitle: "Atención",
		attentionBannerMessage:
			"Las solicitudes realizadas después de las 10:30 h (hora de Brasilia) se procesarán al día siguiente.",
		bankDataTitle: "Datos bancarios",
		holderLabel: "Titular de la cuenta",
		accountTypeLabel: "Tipo de cuenta",
		agencyLabel: "Agencia",
		accountNumberLabel: "Cuenta",
		pixKeyLabel: "Clave PIX",
	},
	completion: {
		title: "¡Todo listo!",
		description:
			"El valor solicitado para el retiro está siendo procesado por el equipo Financiero.",
	},
	partialFailure: {
		modalTitle: "Solicitud procesada parcialmente",
		modalDescription:
			"Parte de su solicitud se procesó, pero la otra parte no pudo completarse.",
		title: "Procesamiento incompleto",
		message:
			"Parte de la operación se completó, pero la otra parte falló. Revise el extracto y vuelva a intentar lo que faltó.",
		notification:
			"Solicitud procesada parcialmente — revise el extracto y vuelva a intentar lo que faltó.",
	},
};
